import React, { Fragment } from 'react';
import { BotIframe } from './BotIframe';
import {
    Steps, StepsIndicator, Line, Step, StepsText, StepText
} from './index.style';

export const Bot2 = ({ code, source, lead, content: { step1, step2, step3 } }) => {
    return (<Fragment>
        <Steps>
            <StepsIndicator>
                <Line />
                <Step active>1</Step>
                <Step>2</Step>
                <Step>3</Step>
            </StepsIndicator>
            <StepsText>
                <StepText active>{step1.text}</StepText>
                <StepText>{step2.text}</StepText>
                <StepText>{step3.text}</StepText>
            </StepsText>
        </Steps>
        <BotIframe code={code} source={source} lead={lead} />
    </Fragment>);
};
